import { render, staticRenderFns } from "./DomainAuthority.vue?vue&type=template&id=519e47ec&scoped=true&"
import script from "./DomainAuthority.vue?vue&type=script&lang=js&"
export * from "./DomainAuthority.vue?vue&type=script&lang=js&"
import style0 from "./DomainAuthority.vue?vue&type=style&index=0&id=519e47ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e47ec",
  null
  
)

/* custom blocks */
import block0 from "./DomainAuthority.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports